import React, { useContext, useEffect, useCallback, useRef } from 'react'
import ErrorModal from 'core/component/ErrorModal'
import { SpinContext } from 'context'
import {
  setLoginError,
  doLoginWithoutDataTask,
  storeErrorAction,
} from 'core/actions'
import { connect } from 'react-redux'
import LoginScreen from 'core/component/LoginScreen'
import { isDifferentErrorValidate } from 'core'

const ErrorContext = React.createContext(null)
const ErrorContextProviderComp = ({
  children,
  setLoginErrorInfo,
  doLoginWithoutDataTaskSupport,
  error,
  setErrorInfo,
}) => {
  // const [error, setErrorInfo] = useState()
  const { setSpinning } = useContext(SpinContext)
  useEffect(
    _ => {
      setSpinning(false)
      if (error && error.appExceptionId === 100) {
        setLoginErrorInfo(error)
        // window.localStorage.removeItem('pgads-jwt')
        // window.location.reload()
      }
    },
    [error, setLoginErrorInfo, setSpinning]
  )
  const errorRef = useRef(error)
  const setErrorInfoRef = useRef(setErrorInfo)

  useEffect(() => {
    errorRef.current = error
    setErrorInfoRef.current = setErrorInfo
  })

  const setError = useCallback((curError, dialogCloseFunction) => {
    dialogCloseFunction && dialogCloseFunction()
    // if (!R.equals(error, curError)) setErrorInfo(curError)
    if (isDifferentErrorValidate(curError, errorRef.current)) {
      setErrorInfoRef.current(curError)
    }
  }, [])

  // from LoginScreen Comp , we need to clear error
  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {error && error.appExceptionId !== 100 && (
        <ErrorModal key="err" modalInfo={error} setModalInfo={setError} />
      )}
      {/* error.httpStatus === 403 */}
      {error && error.appExceptionId === 100 && (
        <LoginScreen
          doLoginWithoutDataTaskSupport={doLoginWithoutDataTaskSupport}
        />
      )}
      {children}
    </ErrorContext.Provider>
  )
}

const mapStateToProps = state => ({
  error: state.core.error,
})

const mapDispatchToProps = dispatch => ({
  setLoginErrorInfo: error => dispatch(setLoginError(error)),
  doLoginWithoutDataTaskSupport: argv => dispatch(doLoginWithoutDataTask(argv)),
  setErrorInfo: error => storeErrorAction(error)(dispatch),
})

export const ErrorContextProvider = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorContextProviderComp)

export default ErrorContext
